import { LogManager } from '../../../../common/port/log/log.manager.port';
import { AccountCallsSummaryAggregateRootMapper } from '../../../../infrastructure/mappers/org-metrics/calls/account-calls-summary.aggregate-root.mapper';
import { GetAccountCallsSummaryRequestDto } from '../../../dtos/org-metrics/calls/get-account-calls-summary-request.dto';
import { GetAccountCallsSummaryResponseDto } from '../../../dtos/org-metrics/calls/get-account-calls-summary-response.dto';
import { GetAccountCallsSummaryQuery } from '../../../queries/org-metrics/calls/get-account-calls-summary.query';

export class GetAccountCallsSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountCallsSummaryQuery,
    protected readonly mapper: AccountCallsSummaryAggregateRootMapper
  ) {}

  async get(
    props: GetAccountCallsSummaryRequestDto
  ): Promise<GetAccountCallsSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountCallsSummaryController.get encountered an error ${error}`
      );
    }
  }
}
